import { render, staticRenderFns } from "./TheOnHoldTable.vue?vue&type=template&id=19485ccf"
import script from "./TheOnHoldTable.vue?vue&type=script&lang=js"
export * from "./TheOnHoldTable.vue?vue&type=script&lang=js"
import style0 from "./TheOnHoldTable.vue?vue&type=style&index=0&id=19485ccf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports